var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.btnClass,attrs:{"id":"elCta-partner","loading":_vm.isLoading,"elevation":"0"},on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.txt)+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65d7f2e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globalUiComponents/btn/BtnCta.vue
// module id = null
// module chunks = 